export default __webpack_public_path__ + "fonts/MYRIADPRO-SEMIBOLD.6fd5c55d90e96c8af1041794ab70f5f2.woff";